import { graphql } from "react-relay";

export const CreateOnboardingRequestMutation = graphql`
  mutation CreateOnboardingRequestMutation($input: CreateOnboardingInput!) {
    createOnboarding(input: $input) {
      onboardingRequest {
        id
        status
        onboardingType
      }
      error
    }
  }
`;